export const keySeen = `_bannerSurveySeen`;
export const keyMaxSeen = 10; // definisce quante volte il banner puo' essere visto prima di essere bloccato
export const keyClicked = `_bannerSurveyClicked2025`;
